export function blockquoteSlider() {
  const slider = $(".blockquote-slider");
  slider.on("init", function (event, slick) {
    $(".slick-current").addClass("animate");
  });
  slider.find(".slides").slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true
  }).on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    $(".slick-slide").eq(currentSlide).removeClass("animate");
  }).on("afterChange", function (event, slick, currentSlide) {
    $(".slick-slide").eq(currentSlide).addClass("animate");
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/blockquoteSlider.js